import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { httpOk, POST, GET } from 'helpers/api';

function Index() {
	const { t } = useTranslation()

	const types = [
		{ 'name': 'order_types' },
		{ 'name': 'user_role_types' },
		{ 'name': 'delivery_rules_types' },
		{ 'name': 'employee_bonuses_types' },
		{ 'name': 'products_types' },
		{ 'name': 'products_system_types' },
		{ 'name': 'employee_salary_types' },
		{ 'name': 'loyalty_service_types' },
		{ 'name': 'payment_purpose_types' },
		{ 'name': 'auto_add_rules_types' },
		{ 'name': 'sms_types' },
		{ 'name': 'permissions' },
		{ 'name': 'permissions_categories' },
		{ 'name': 'counterparties' },
		{ 'name': 'cheques_statuses_types' },
	]
	const [languages, setLanguages] = useState([])
	const [selectedType, setSelectedType] = useState('')

	async function createTranslation() {
		await POST(`/admin/languages`, {
			'type': selectedType,
			'languages': languages
		}, { loader: true })
	}

	function handleChange(e, languageIndex, index) {
		var languagesCopy = [...languages]
		languagesCopy[languageIndex].data[index]['value'] = e.target.value;
		setLanguages(languagesCopy)
	}

	async function getData(type) {
		var languagesCopy = [...languages]
		const response = await GET(`/admin/db-types`, { 'type': type }, { loader: true })

		if (httpOk(response)) {
			for (let i = 0; i < languagesCopy.length; i++) {
				languagesCopy[i]['data'] = []
				for (let j = 0; j < response.data.data.length; j++) {
					var item = response.data.dataTranslations.find(item => item.entity_id === response.data.data[j]['id'] && item.language === languagesCopy[i]['code']);
					if (item?.language === languagesCopy[i]['code']) {
						response.data.data[j]['value'] = item.value;
					} else {
						response.data.data[j]['value'] = '';
					}
					languagesCopy[i]['data'].push({ ...response.data.data[j] })
				}
			}

			setSelectedType(type)
			setLanguages(languagesCopy)
		}
	}

	async function getLanguages() {
		const response = await GET(`/admin/languages`, {}, { loader: true })
		if (httpOk(response)) setLanguages(response.data)
	}

	useEffect(() => {
		getLanguages()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('languages')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex gap-2" style={{ 'minHeight': '600px', 'overflow': 'auto' }}>
						<div className="d-flex flex-column gap-2" style={{ width: '15%' }}>
							{types.map((item, index) => (
								<div className={`tab ${item.name === selectedType ? 'active' : ''}`} key={index} onClick={() => getData(item.name)}>{item.name}</div>
							))}
						</div>
						<div className="container-fluid">
							<div className="row w-100">
								{languages?.map((language, languageIndex) => (
									<div className="col-md-3" key={languageIndex}>
										<h5 className="mb-3">
											{language.name} - {language.code}
										</h5>

										{language?.data?.map((item, index) => (
											<div className="mb-2" key={index}>
												<label style={{ 'width': '100px' }} className="vertical-center">
													{item.id}. {item.name}
												</label>
												<input type="text" className="form-control" value={item.value}
													onChange={(e) => handleChange(e, languageIndex, index)} />
											</div>
										))}
									</div>
								))}
							</div>
						</div>
					</div>

					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-primary w-100"
							onClick={() => createTranslation()}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index